// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Chat operativo aprobado.
 * Este archivo es la única fuente visual para los ejemplos de hilo de solicitud.
 */
.drawer-layer {
  position: fixed;
  inset: 0;
  z-index: 5000;
  visibility: hidden;
  pointer-events: none;
}

.drawer-layer.is-open {
  visibility: visible;
  pointer-events: auto;
}

.drawer-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(19, 35, 29, 0.12);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.22s ease;
}

.drawer-layer.is-open .drawer-backdrop {
  opacity: 1;
  pointer-events: auto;
}

.message-drawer {
  position: absolute;
  top: 104px;
  right: 24px;
  width: min(440px, calc(100% - 32px));
  height: min(720px, calc(100% - 136px));
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  border: 1px solid rgba(19, 35, 29, 0.07);
  border-radius: 26px;
  background: #f7f5f1;
  box-shadow: 0 24px 80px rgba(19, 35, 29, 0.18);
  opacity: 0;
  pointer-events: auto;
  transform: translateY(18px) scale(0.985);
  transform-origin: bottom right;
  transition: transform 0.24s ease, opacity 0.2s ease;
}

.drawer-layer.is-open .message-drawer {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.drawer-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid rgba(19, 35, 29, 0.08);
  background: rgba(247, 245, 241, 0.97);
}

.drawer-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  border: 2px solid rgba(130, 177, 148, 0.35);
  border-radius: 50%;
  background: #dde8e1;
  object-fit: cover;
}

.drawer-person {
  min-width: 0;
  flex: 1 1;
}

.drawer-person strong,
.drawer-person span {
  display: block;
}

.drawer-person strong {
  overflow: hidden;
  font-size: 15px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-person span {
  margin-top: 2px;
  color: #65756e;
  font-size: 12px;
}

.drawer-close {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #5f6b65;
  font-size: 20px;
  cursor: pointer;
}

.drawer-close:hover {
  background: rgba(19, 35, 29, 0.06);
}

.conversation {
  min-height: 0;
  overflow: auto;
  padding: 20px;
  background: linear-gradient(180deg, rgba(130, 177, 148, 0.06), transparent 42%);
}

.conversation-date {
  margin-bottom: 15px;
  color: #65756e;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.system-message {
  margin-top: 12px;
  padding: 17px;
  border: 1px solid rgba(130, 177, 148, 0.3);
  border-radius: 18px;
  background: #f1f6f2;
}

.system-message:first-child {
  margin-top: 0;
}

.system-message.proposal-history {
  border-color: rgba(19, 35, 29, 0.12);
  background: rgba(247, 245, 241, 0.72);
}

.proposal-history .status-icon.history {
  background: rgba(19, 35, 29, 0.08);
  color: #5f726b;
}

.proposal-history .proposal-choice {
  background: rgba(255, 255, 255, 0.44);
}

.system-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 800;
}

.system-title-copy {
  min-width: 0;
  flex: 1 1;
}

.system-title-copy strong,
.system-title-copy span {
  display: block;
}

.system-title-copy strong {
  font-size: 14px;
  line-height: 1.35;
}

.system-title-copy span {
  margin-top: 2px;
  color: #6d7b74;
  font-size: 10px;
  font-weight: 650;
  line-height: 1.4;
}

.status-icon {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #82b194;
  color: #fff;
  font-size: 12px;
}

.status-icon.warning {
  background: #a87c50;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.summary-item {
  padding: 10px 11px;
  border: 1px solid rgba(19, 35, 29, 0.07);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.62);
}

.summary-item.full {
  grid-column: 1 / -1;
}

.summary-item span,
.summary-item strong {
  display: block;
}

.summary-item span {
  margin-bottom: 3px;
  color: #65756e;
  font-size: 11px;
  font-weight: 700;
}

.summary-item strong {
  font-size: 13px;
  line-height: 1.45;
}

.system-foot {
  margin: 12px 0 0;
  color: #65756e;
  font-size: 12px;
  line-height: 1.6;
}

.message-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-top: 14px;
}

.message-row.user,
.message-row.sent {
  justify-content: flex-end;
}

.message-row.professional,
.message-row.received {
  justify-content: flex-start;
}

.message-avatar {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 1px solid rgba(19, 35, 29, 0.09);
  border-radius: 50%;
  background: #f8f6f2;
  object-fit: cover;
}

.chat-bubble {
  width: fit-content;
  max-width: 78%;
  margin: 0;
  padding: 10px 13px;
  border-radius: 15px;
  font-size: 15px;
  line-height: 1.5;
}

.message-row.user .chat-bubble,
.message-row.sent .chat-bubble {
  border-radius: 15px 15px 4px 15px;
  background: #82b194;
  color: #fff;
  box-shadow: 0 8px 18px rgba(130, 177, 148, 0.2);
}

.message-row.professional .chat-bubble,
.message-row.received .chat-bubble {
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 15px 15px 15px 4px;
  background: #fff;
  color: #13231d;
}

.proposal-list {
  display: grid;
  gap: 7px;
}

.proposal-choice {
  width: 100%;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  padding: 10px;
  border: 1px solid rgba(19, 35, 29, 0.09);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.66);
  color: #13231d;
  text-align: left;
}

.proposal-choice:not(:disabled) {
  cursor: pointer;
}

.proposal-choice:not(:disabled):hover,
.proposal-choice.is-selected {
  border-color: rgba(130, 177, 148, 0.62);
  background: rgba(130, 177, 148, 0.1);
}

.proposal-radio {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(130, 177, 148, 0.75);
  border-radius: 50%;
}

.proposal-choice.is-selected .proposal-radio {
  background: #82b194;
  box-shadow: inset 0 0 0 3px #f7f5f1;
}

.proposal-copy strong,
.proposal-copy span {
  display: block;
}

.proposal-copy strong {
  font-size: 11px;
}

.proposal-copy span {
  margin-top: 2px;
  color: #6d7a73;
  font-size: 9px;
}

.proposal-price {
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.deadline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding: 9px 10px;
  border-radius: 11px;
  background: rgba(184, 128, 41, 0.1);
  color: #72571f;
}

.deadline span {
  font-size: 10px;
  font-weight: 750;
}

.deadline strong {
  font-size: 11px;
  white-space: nowrap;
}

.chat-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  margin-top: 11px;
}

.chat-button {
  min-height: 42px;
  padding: 0 14px;
  border-radius: 13px;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.chat-button.primary {
  border: 1px solid #82b194;
  background: #82b194;
  color: #fff;
}

.chat-button.primary:hover {
  background: #76a789;
}

.chat-button.secondary {
  min-width: 126px;
  border: 1px solid rgba(130, 177, 148, 0.58);
  background: transparent;
  color: #416650;
}

.chat-button.secondary:hover {
  background: rgba(130, 177, 148, 0.1);
}

.response-form {
  display: grid;
  gap: 10px;
}

.response-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7px;
}

.response-tab {
  min-height: 42px;
  padding: 7px;
  border: 1px solid rgba(19, 35, 29, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.66);
  color: #617068;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

.response-tab.is-active {
  border-color: rgba(130, 177, 148, 0.62);
  background: rgba(130, 177, 148, 0.12);
  color: #31513f;
}

.alternative-list {
  display: grid;
  gap: 7px;
}

.alternative-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(122px, 1.2fr) minmax(72px, 0.68fr) minmax(92px, 0.92fr) 28px;
  gap: 6px;
  align-items: end;
  padding: 9px;
  border: 1px solid rgba(19, 35, 29, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.55);
}

.alternative-label {
  grid-column: 1 / -1;
  color: #416650;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.alternative-row.single {
  grid-template-columns: minmax(142px, 1.25fr) minmax(76px, 0.7fr) minmax(100px, 0.9fr);
}

.response-field {
  min-width: 0;
}

.response-field label {
  display: block;
  margin: 0 0 4px;
  color: #65756e;
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
}

.response-field input,
.response-field select,
.reject-panel textarea {
  width: 100%;
  border: 1px solid rgba(19, 35, 29, 0.1);
  border-radius: 9px;
  background: #fbfaf7;
  color: #13231d;
  font: inherit;
  outline: none;
}

.response-field input,
.response-field select {
  height: 37px;
  padding: 0 7px;
  font-size: 9px;
  font-weight: 700;
}

.response-field input:focus,
.response-field select:focus,
.reject-panel textarea:focus {
  border-color: rgba(130, 177, 148, 0.78);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.13);
}

.remove-alternative {
  width: 28px;
  height: 37px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #8b5a52;
  font-size: 17px;
  cursor: pointer;
}

.remove-alternative:hover {
  background: rgba(155, 90, 80, 0.09);
}

.add-alternative {
  justify-self: start;
  min-height: 34px;
  padding: 0 10px;
  border: 1px dashed rgba(130, 177, 148, 0.62);
  border-radius: 10px;
  background: transparent;
  color: #416650;
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
}

.add-alternative:hover {
  background: rgba(130, 177, 148, 0.09);
}

.reject-panel {
  padding: 10px;
  border: 1px solid rgba(155, 90, 80, 0.2);
  border-radius: 12px;
  background: rgba(155, 90, 80, 0.055);
}

.reject-panel label {
  display: block;
  margin-bottom: 6px;
  color: #6b4944;
  font-size: 10px;
  font-weight: 800;
}

.reject-panel textarea {
  min-height: 78px;
  resize: vertical;
  padding: 9px 10px;
  font-size: 10px;
  line-height: 1.5;
}

.form-error {
  display: none;
  margin: 0;
  color: #955248;
  font-size: 9px;
  font-weight: 750;
  line-height: 1.45;
}

.form-error.is-visible {
  display: block;
}

.closed-summary {
  text-align: center;
}

.closed-summary .status-icon {
  width: 38px;
  height: 38px;
  margin: 0 auto 9px;
  font-size: 17px;
}

.closed-summary h3 {
  margin: 0 0 6px;
  font-size: 15px;
}

.closed-summary p {
  margin: 0;
  color: #5f6f67;
  font-size: 11px;
  line-height: 1.55;
}

.restart-flow {
  margin-top: 14px;
}

.thread-closed-note {
  display: block;
  margin: 10px 0 0;
  color: #728078;
  font-size: 10px;
  font-weight: 750;
  text-align: center;
}

.drawer-composer {
  display: flex;
  gap: 8px;
  padding: 12px 14px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid rgba(19, 35, 29, 0.08);
  background: #f7f5f1;
}

.drawer-composer input {
  min-width: 0;
  flex: 1 1;
  padding: 0 12px;
  border: 1px solid rgba(19, 35, 29, 0.1);
  border-radius: 14px;
  background: #f8f6f2;
  color: #13231d;
  font: inherit;
  font-size: 15px;
  outline: none;
}

.drawer-composer input:focus {
  border-color: rgba(130, 177, 148, 0.7);
}

.drawer-composer button {
  min-height: 42px;
  padding: 0 16px;
  border: 0;
  border-radius: 13px;
  background: #82b194;
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.drawer-composer.is-closed input {
  background: #ecede9;
  color: #7b8781;
}

.drawer-composer.is-closed button {
  background: #c7cec9;
  cursor: default;
}

@media (max-width: 600px) {
  .drawer-layer {
    inset: 72px 0 0;
  }

  .message-drawer {
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 0;
    transform: translateY(16px);
  }

  .drawer-backdrop {
    display: none;
  }

  .summary-grid,
  .response-tabs,
  .alternative-row,
  .alternative-row.single {
    grid-template-columns: 1fr;
  }

  .summary-item.full {
    grid-column: auto;
  }

  .remove-alternative {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .chat-actions {
    grid-template-columns: 1fr;
  }

  .chat-button.secondary {
    min-width: 0;
  }
}

/* ── System message variants: expired / rejected (centered layout) ── */
.system-message--expired,
.system-message--rejected {
  text-align: center;
}

.schedule-request-container {
  margin-top: 12px;
}

.system-message--expired .system-title--centered,
.system-message--rejected .system-title--centered {
  justify-content: center;
  margin-bottom: 8px;
}

.status-icon--large {
  width: 52px;
  height: 52px;
  font-size: 24px;
  border-radius: 50%;
  background: #b5855a22;
  color: #b5855a;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
}

.system-title-copy--centered {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
}

.system-title-copy--centered strong {
  font-size: 15px;
  color: #13231d;
}

.system-title-copy--centered span {
  font-size: 13px;
  color: #6b7c74;
  max-width: 280px;
}

/* System link (e.g. "Ver estado al vencer las 12 h") */
.system-link {
  display: block;
  margin-top: 8px;
  font-size: 12px;
  color: #3d7a5e;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/approved-chat.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;EACV,oBAAoB;EACpB,wCAAwC;EACxC,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,+EAA+E;AACjF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;;EAEE,wCAAwC;EACxC,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0FAA0F;EAC1F,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,2DAA2D;EAC3D,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,wEAAwE;AACxE;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["/*\n * Chat operativo aprobado.\n * Este archivo es la única fuente visual para los ejemplos de hilo de solicitud.\n */\n.drawer-layer {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.drawer-layer.is-open {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.drawer-backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(19, 35, 29, 0.12);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.22s ease;\n}\n\n.drawer-layer.is-open .drawer-backdrop {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.message-drawer {\n  position: absolute;\n  top: 104px;\n  right: 24px;\n  width: min(440px, calc(100% - 32px));\n  height: min(720px, calc(100% - 136px));\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  overflow: hidden;\n  border: 1px solid rgba(19, 35, 29, 0.07);\n  border-radius: 26px;\n  background: #f7f5f1;\n  box-shadow: 0 24px 80px rgba(19, 35, 29, 0.18);\n  opacity: 0;\n  pointer-events: auto;\n  transform: translateY(18px) scale(0.985);\n  transform-origin: bottom right;\n  transition: transform 0.24s ease, opacity 0.2s ease;\n}\n\n.drawer-layer.is-open .message-drawer {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n\n.drawer-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid rgba(19, 35, 29, 0.08);\n  background: rgba(247, 245, 241, 0.97);\n}\n\n.drawer-avatar {\n  width: 42px;\n  height: 42px;\n  flex: 0 0 42px;\n  border: 2px solid rgba(130, 177, 148, 0.35);\n  border-radius: 50%;\n  background: #dde8e1;\n  object-fit: cover;\n}\n\n.drawer-person {\n  min-width: 0;\n  flex: 1;\n}\n\n.drawer-person strong,\n.drawer-person span {\n  display: block;\n}\n\n.drawer-person strong {\n  overflow: hidden;\n  font-size: 15px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.drawer-person span {\n  margin-top: 2px;\n  color: #65756e;\n  font-size: 12px;\n}\n\n.drawer-close {\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #5f6b65;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.drawer-close:hover {\n  background: rgba(19, 35, 29, 0.06);\n}\n\n.conversation {\n  min-height: 0;\n  overflow: auto;\n  padding: 20px;\n  background: linear-gradient(180deg, rgba(130, 177, 148, 0.06), transparent 42%);\n}\n\n.conversation-date {\n  margin-bottom: 15px;\n  color: #65756e;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.system-message {\n  margin-top: 12px;\n  padding: 17px;\n  border: 1px solid rgba(130, 177, 148, 0.3);\n  border-radius: 18px;\n  background: #f1f6f2;\n}\n\n.system-message:first-child {\n  margin-top: 0;\n}\n\n.system-message.proposal-history {\n  border-color: rgba(19, 35, 29, 0.12);\n  background: rgba(247, 245, 241, 0.72);\n}\n\n.proposal-history .status-icon.history {\n  background: rgba(19, 35, 29, 0.08);\n  color: #5f726b;\n}\n\n.proposal-history .proposal-choice {\n  background: rgba(255, 255, 255, 0.44);\n}\n\n.system-title {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 12px;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.system-title-copy {\n  min-width: 0;\n  flex: 1;\n}\n\n.system-title-copy strong,\n.system-title-copy span {\n  display: block;\n}\n\n.system-title-copy strong {\n  font-size: 14px;\n  line-height: 1.35;\n}\n\n.system-title-copy span {\n  margin-top: 2px;\n  color: #6d7b74;\n  font-size: 10px;\n  font-weight: 650;\n  line-height: 1.4;\n}\n\n.status-icon {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: #82b194;\n  color: #fff;\n  font-size: 12px;\n}\n\n.status-icon.warning {\n  background: #a87c50;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.summary-item {\n  padding: 10px 11px;\n  border: 1px solid rgba(19, 35, 29, 0.07);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.62);\n}\n\n.summary-item.full {\n  grid-column: 1 / -1;\n}\n\n.summary-item span,\n.summary-item strong {\n  display: block;\n}\n\n.summary-item span {\n  margin-bottom: 3px;\n  color: #65756e;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.summary-item strong {\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.system-foot {\n  margin: 12px 0 0;\n  color: #65756e;\n  font-size: 12px;\n  line-height: 1.6;\n}\n\n.message-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.message-row.user,\n.message-row.sent {\n  justify-content: flex-end;\n}\n\n.message-row.professional,\n.message-row.received {\n  justify-content: flex-start;\n}\n\n.message-avatar {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border: 1px solid rgba(19, 35, 29, 0.09);\n  border-radius: 50%;\n  background: #f8f6f2;\n  object-fit: cover;\n}\n\n.chat-bubble {\n  width: fit-content;\n  max-width: 78%;\n  margin: 0;\n  padding: 10px 13px;\n  border-radius: 15px;\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.message-row.user .chat-bubble,\n.message-row.sent .chat-bubble {\n  border-radius: 15px 15px 4px 15px;\n  background: #82b194;\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(130, 177, 148, 0.2);\n}\n\n.message-row.professional .chat-bubble,\n.message-row.received .chat-bubble {\n  border: 1px solid rgba(19, 35, 29, 0.08);\n  border-radius: 15px 15px 15px 4px;\n  background: #fff;\n  color: #13231d;\n}\n\n.proposal-list {\n  display: grid;\n  gap: 7px;\n}\n\n.proposal-choice {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 18px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 9px;\n  padding: 10px;\n  border: 1px solid rgba(19, 35, 29, 0.09);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.66);\n  color: #13231d;\n  text-align: left;\n}\n\n.proposal-choice:not(:disabled) {\n  cursor: pointer;\n}\n\n.proposal-choice:not(:disabled):hover,\n.proposal-choice.is-selected {\n  border-color: rgba(130, 177, 148, 0.62);\n  background: rgba(130, 177, 148, 0.1);\n}\n\n.proposal-radio {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(130, 177, 148, 0.75);\n  border-radius: 50%;\n}\n\n.proposal-choice.is-selected .proposal-radio {\n  background: #82b194;\n  box-shadow: inset 0 0 0 3px #f7f5f1;\n}\n\n.proposal-copy strong,\n.proposal-copy span {\n  display: block;\n}\n\n.proposal-copy strong {\n  font-size: 11px;\n}\n\n.proposal-copy span {\n  margin-top: 2px;\n  color: #6d7a73;\n  font-size: 9px;\n}\n\n.proposal-price {\n  font-size: 10px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.deadline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n  padding: 9px 10px;\n  border-radius: 11px;\n  background: rgba(184, 128, 41, 0.1);\n  color: #72571f;\n}\n\n.deadline span {\n  font-size: 10px;\n  font-weight: 750;\n}\n\n.deadline strong {\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.chat-actions {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 8px;\n  margin-top: 11px;\n}\n\n.chat-button {\n  min-height: 42px;\n  padding: 0 14px;\n  border-radius: 13px;\n  font-size: 11px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.chat-button.primary {\n  border: 1px solid #82b194;\n  background: #82b194;\n  color: #fff;\n}\n\n.chat-button.primary:hover {\n  background: #76a789;\n}\n\n.chat-button.secondary {\n  min-width: 126px;\n  border: 1px solid rgba(130, 177, 148, 0.58);\n  background: transparent;\n  color: #416650;\n}\n\n.chat-button.secondary:hover {\n  background: rgba(130, 177, 148, 0.1);\n}\n\n.response-form {\n  display: grid;\n  gap: 10px;\n}\n\n.response-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 7px;\n}\n\n.response-tab {\n  min-height: 42px;\n  padding: 7px;\n  border: 1px solid rgba(19, 35, 29, 0.1);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.66);\n  color: #617068;\n  font-size: 10px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.response-tab.is-active {\n  border-color: rgba(130, 177, 148, 0.62);\n  background: rgba(130, 177, 148, 0.12);\n  color: #31513f;\n}\n\n.alternative-list {\n  display: grid;\n  gap: 7px;\n}\n\n.alternative-row {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(122px, 1.2fr) minmax(72px, 0.68fr) minmax(92px, 0.92fr) 28px;\n  gap: 6px;\n  align-items: end;\n  padding: 9px;\n  border: 1px solid rgba(19, 35, 29, 0.08);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.alternative-label {\n  grid-column: 1 / -1;\n  color: #416650;\n  font-size: 9px;\n  font-weight: 850;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.alternative-row.single {\n  grid-template-columns: minmax(142px, 1.25fr) minmax(76px, 0.7fr) minmax(100px, 0.9fr);\n}\n\n.response-field {\n  min-width: 0;\n}\n\n.response-field label {\n  display: block;\n  margin: 0 0 4px;\n  color: #65756e;\n  font-size: 8px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.response-field input,\n.response-field select,\n.reject-panel textarea {\n  width: 100%;\n  border: 1px solid rgba(19, 35, 29, 0.1);\n  border-radius: 9px;\n  background: #fbfaf7;\n  color: #13231d;\n  font: inherit;\n  outline: none;\n}\n\n.response-field input,\n.response-field select {\n  height: 37px;\n  padding: 0 7px;\n  font-size: 9px;\n  font-weight: 700;\n}\n\n.response-field input:focus,\n.response-field select:focus,\n.reject-panel textarea:focus {\n  border-color: rgba(130, 177, 148, 0.78);\n  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.13);\n}\n\n.remove-alternative {\n  width: 28px;\n  height: 37px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: #8b5a52;\n  font-size: 17px;\n  cursor: pointer;\n}\n\n.remove-alternative:hover {\n  background: rgba(155, 90, 80, 0.09);\n}\n\n.add-alternative {\n  justify-self: start;\n  min-height: 34px;\n  padding: 0 10px;\n  border: 1px dashed rgba(130, 177, 148, 0.62);\n  border-radius: 10px;\n  background: transparent;\n  color: #416650;\n  font-size: 9px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.add-alternative:hover {\n  background: rgba(130, 177, 148, 0.09);\n}\n\n.reject-panel {\n  padding: 10px;\n  border: 1px solid rgba(155, 90, 80, 0.2);\n  border-radius: 12px;\n  background: rgba(155, 90, 80, 0.055);\n}\n\n.reject-panel label {\n  display: block;\n  margin-bottom: 6px;\n  color: #6b4944;\n  font-size: 10px;\n  font-weight: 800;\n}\n\n.reject-panel textarea {\n  min-height: 78px;\n  resize: vertical;\n  padding: 9px 10px;\n  font-size: 10px;\n  line-height: 1.5;\n}\n\n.form-error {\n  display: none;\n  margin: 0;\n  color: #955248;\n  font-size: 9px;\n  font-weight: 750;\n  line-height: 1.45;\n}\n\n.form-error.is-visible {\n  display: block;\n}\n\n.closed-summary {\n  text-align: center;\n}\n\n.closed-summary .status-icon {\n  width: 38px;\n  height: 38px;\n  margin: 0 auto 9px;\n  font-size: 17px;\n}\n\n.closed-summary h3 {\n  margin: 0 0 6px;\n  font-size: 15px;\n}\n\n.closed-summary p {\n  margin: 0;\n  color: #5f6f67;\n  font-size: 11px;\n  line-height: 1.55;\n}\n\n.restart-flow {\n  margin-top: 14px;\n}\n\n.thread-closed-note {\n  display: block;\n  margin: 10px 0 0;\n  color: #728078;\n  font-size: 10px;\n  font-weight: 750;\n  text-align: center;\n}\n\n.drawer-composer {\n  display: flex;\n  gap: 8px;\n  padding: 12px 14px calc(12px + env(safe-area-inset-bottom));\n  border-top: 1px solid rgba(19, 35, 29, 0.08);\n  background: #f7f5f1;\n}\n\n.drawer-composer input {\n  min-width: 0;\n  flex: 1;\n  padding: 0 12px;\n  border: 1px solid rgba(19, 35, 29, 0.1);\n  border-radius: 14px;\n  background: #f8f6f2;\n  color: #13231d;\n  font: inherit;\n  font-size: 15px;\n  outline: none;\n}\n\n.drawer-composer input:focus {\n  border-color: rgba(130, 177, 148, 0.7);\n}\n\n.drawer-composer button {\n  min-height: 42px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 13px;\n  background: #82b194;\n  color: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.drawer-composer.is-closed input {\n  background: #ecede9;\n  color: #7b8781;\n}\n\n.drawer-composer.is-closed button {\n  background: #c7cec9;\n  cursor: default;\n}\n\n@media (max-width: 600px) {\n  .drawer-layer {\n    inset: 72px 0 0;\n  }\n\n  .message-drawer {\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n    transform: translateY(16px);\n  }\n\n  .drawer-backdrop {\n    display: none;\n  }\n\n  .summary-grid,\n  .response-tabs,\n  .alternative-row,\n  .alternative-row.single {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-item.full {\n    grid-column: auto;\n  }\n\n  .remove-alternative {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n  }\n\n  .chat-actions {\n    grid-template-columns: 1fr;\n  }\n\n  .chat-button.secondary {\n    min-width: 0;\n  }\n}\n\n/* ── System message variants: expired / rejected (centered layout) ── */\n.system-message--expired,\n.system-message--rejected {\n  text-align: center;\n}\n\n.schedule-request-container {\n  margin-top: 12px;\n}\n\n.system-message--expired .system-title--centered,\n.system-message--rejected .system-title--centered {\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.status-icon--large {\n  width: 52px;\n  height: 52px;\n  font-size: 24px;\n  border-radius: 50%;\n  background: #b5855a22;\n  color: #b5855a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 8px;\n}\n\n.system-title-copy--centered {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  text-align: center;\n}\n\n.system-title-copy--centered strong {\n  font-size: 15px;\n  color: #13231d;\n}\n\n.system-title-copy--centered span {\n  font-size: 13px;\n  color: #6b7c74;\n  max-width: 280px;\n}\n\n/* System link (e.g. \"Ver estado al vencer las 12 h\") */\n.system-link {\n  display: block;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #3d7a5e;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
